import { Popover as ChakraPopover, Portal } from '@chakra-ui/react'
import * as React from 'react'

export interface PopoverProps extends ChakraPopover.RootProps {
  children: React.ReactNode
  open?: boolean
  onOpenChange?: (details: { open: boolean }) => void
  [key: string]: any
}

export const Popover: React.FC<PopoverProps> = (props) => {
  const { children, open, onOpenChange, ...rest } = props

  return (
    <ChakraPopover.Root open={open} onOpenChange={onOpenChange} {...rest}>
      {children}
    </ChakraPopover.Root>
  )
}

export interface PopoverContentProps extends ChakraPopover.ContentProps {
  portalled?: boolean
  portalRef?: React.RefObject<HTMLElement | null>
  [key: string]: any
}

export const PopoverContent = React.forwardRef<
  HTMLDivElement,
  PopoverContentProps
>(function PopoverContent(props, ref) {
  const { portalled = true, portalRef, children, ...rest } = props

  const content = (
    <ChakraPopover.Positioner>
      <ChakraPopover.Content ref={ref} {...rest}>
        {children}
      </ChakraPopover.Content>
    </ChakraPopover.Positioner>
  )

  if (portalled) {
    return <Portal container={portalRef}>{content}</Portal>
  }

  return content
})

export interface PopoverArrowProps extends ChakraPopover.ArrowProps {
  [key: string]: any
}

export const PopoverArrow = React.forwardRef<HTMLDivElement, PopoverArrowProps>(
  function PopoverArrow(props, ref) {
    return (
      <ChakraPopover.Arrow {...props} ref={ref}>
        <ChakraPopover.ArrowTip />
      </ChakraPopover.Arrow>
    )
  },
)

export const PopoverCloseButton = React.forwardRef<
  HTMLButtonElement,
  ChakraPopover.CloseTriggerProps
>(function PopoverCloseButton(props, ref) {
  return (
    <ChakraPopover.CloseTrigger
      position="absolute"
      top="1"
      insetEnd="1"
      {...props}
      ref={ref}
    />
  )
})

export const PopoverTrigger = ChakraPopover.Trigger
export const PopoverAnchor = ChakraPopover.Anchor
export const PopoverHeader = ChakraPopover.Header
export const PopoverBody = ChakraPopover.Body
export const PopoverFooter = ChakraPopover.Footer
export const PopoverTitle = ChakraPopover.Title
export const PopoverDescription = ChakraPopover.Description
export const PopoverPositioner = ChakraPopover.Positioner
